import { post, get, } from "@utils/axios";

const api = "user-case-management";

export const getNotificationReq = () => {
  return get(`${api}/get-case-notifications`);
}

/** Sidebar bubbles and the doctor's on-hold alert. */
export const getCaseCountsReq = () => {
  return get(`${api}/get-case-counts`);
}